import React from 'react';
import Congratulations from './Congratulations';
import ManagerReport from './ManagerReport';
import TeamReport from './TeamReport';
import Feedback from './Feedback';
import Solutions from './Solutions';
import Resources from './Resources';
import Management from './Management';

import './manager-dashboard.scss';
import useWindowSize from '../../utils/useWindowSize';

const ManagerDashboard = ({ userInfo }) => {
  const isClevel = userInfo.role === 'clevel';
  const {
    company: { google_data_studio_url } = {},
    google_data_studio_url: employee_data,
  } = userInfo || {};
  const studio_url = employee_data || google_data_studio_url;
  const { width, height } = useWindowSize();
  const iframeWidth = width < 1280 ? width : width - 300;
  const iframeHeight = width > 767 ? height - 155 : height - 260;
  if (studio_url) {
    return (
      <div className="report-iframe">
        <iframe
          width={iframeWidth}
          height={iframeHeight}
          src={studio_url}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="manager-dashboard">
      <div className="left-part">
        {!isClevel && <Congratulations />}
        <ManagerReport isClevel={isClevel} />
        {isClevel && <Management />}
        <TeamReport />
      </div>
      <div className="right-part">
        <Feedback isClevel={isClevel} />
        <Solutions />
        <Resources isClevel={isClevel} />
      </div>
    </div>
  );
};

export default ManagerDashboard;
